'use client';

import { useProductSearch } from '@/app/components/context/product-search-context';
import { cn } from '@av/utils';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import React from 'react';

const CategoryMenuList = ({
  parentCategoryId,
  childCategoryId,
}: {
  parentCategoryId?: string;
  childCategoryId?: string;
}) => {
  const { categoryItems } = useProductSearch();

  return (
    <ul>
      {categoryItems.map((item) => (
        <li key={item.id} className="">
          <Link
            href={item.pathname}
            className={cn(
              'py-3 px-5 text-base w-full block justify-start flex text-left',
              item?.id && parentCategoryId && +item?.id === +parentCategoryId
                ? 'bg-primary text-white'
                : 'hover:bg-primary/5 hover:text-primary hover:underline'
            )}
          >
            {item.name}
          </Link>
          {parentCategoryId &&
            item?.id &&
            +item.id === +parentCategoryId &&
            !!item.items &&
            item.items.length > 0 && (
              <ul className="bg-[#E3F1FF] py-2">
                {item.items.map((childCategory) => (
                  <li key={childCategory.id} className="">
                    <Link
                      href={childCategory.pathname}
                      className={cn(
                        'py-2 px-5 text-sm justify-between flex items-center w-full transition-colors',
                        childCategory?.id &&
                          childCategoryId &&
                          +childCategory.id === +childCategoryId
                          ? 'text-primary underline'
                          : 'group hover:text-primary hover:underline'
                      )}
                    >
                      {childCategory.name}
                      <div
                        className={cn(
                          'overflow-hidden transition-all text-primary',
                          childCategory?.id &&
                            childCategoryId &&
                            +childCategory?.id === +childCategoryId
                            ? 'translate-x-0'
                            : 'opacity-0 group-hover:opacity-100 -translate-x-4 group-hover:translate-x-0'
                        )}
                      >
                        <ArrowRight className="size-4 min-w-4" />
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
        </li>
      ))}
    </ul>
  );
};

export default CategoryMenuList;
